import { DataGridPremium, GridColDef, useGridApiRef } from '@mui/x-data-grid-premium';
import {  useMemo } from 'react';
import { ulid } from 'ulidx';

export interface IPremMealOrders {
    item : any;
}

function PremMealOrders(props : IPremMealOrders) {
    const apiRef = useGridApiRef();

    const compareSeatNumbers = (a: string, b: string) => {
        const seatRegex = /^(\d+)([A-Za-z]+)$/;

        const matchA = a.match(seatRegex);
        const matchB = b.match(seatRegex);

        if (!matchA || !matchB) {
            return a.localeCompare(b);
        }

        const rowA = Number(matchA[1]);
        const rowB = Number(matchB[1]);

        if (rowA !== rowB) {
            return rowA - rowB;
        }

        return matchA[2].localeCompare(matchB[2], undefined, {
            sensitivity: "base",
        });
    }
  
    const rows = useMemo(() => {
        const result = props?.item?.orders?.flatMap((o : any) => { 
            return o.meals.map((m : any) => {
                return {
                    ...o
                    ,id: ulid().toString()
                    ,meal: m
                    ,feedbacks: (o.feedback ?? []).join(', ')
                }
            });
        }) ?? [];
        return result.sort((a: any,b : any) => compareSeatNumbers(a.seat, b.seat));
        // return result;
    }, [props.item]);

    const columns: GridColDef[] = [ 
        { field: 'seat', headerName: 'Seat', minWidth: 120 },
        { field: 'service', headerName: 'Service', minWidth: 120 },
        { field: 'meal', headerName: 'meal', minWidth: 100 },
        { field: 'feedbacks', headerName: 'Feedback', minWidth: 200 },
        // { field: 'closingCount', headerName: 'Closing', minWidth: 100 },
    ];

    return (
    <>
        <DataGridPremium
            apiRef={apiRef}
            autoHeight
            rows={rows}
            columns={columns}
            editMode='row'
            isCellEditable={(o) => false}
            rowSelection={true}
            getRowClassName={(params) => { return params.indexRelativeToCurrentPage % 2 === 1 ? `tui-grid-alternate-row` : ''}}
            
        />
        {/* { currentFlight && <FlightDetails open={showDetails} flight={currentFlight} cancelAction={() => {setShowDetails(false);}} />} */}
    </>
        
    );
}

export default PremMealOrders;